export default __webpack_public_path__ + "static/monitoring-af17528c989d6eb1abecbc51323fbf7c.png";